import _ from "@lodash";
import React, { useState, useEffect, useRef } from "react";
import axios from "@fuse/utils/axios";
import { AgGridReact } from "ag-grid-react";
import { Tooltip } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import useRouter from "@fuse/hooks/useRouter";
import { dateReformatTo_mmm_dd_yyyy } from '@fuse/utils/dateOperations';
import { formatString } from "@fuse/utils/stringOperations";
import GeneralModal from "@fuse/components/Modal/GeneralModal";
import useToast from "@fuse/hooks/useToast";
import "ag-grid-enterprise";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import "ag-grid-community/styles/ag-theme-material.css";
import "styles/ag-grid-header-style.css";
import { statusColors } from "@fuse/utils/colorName";
import AgGridFilterGroupView from "@fuse/components/AgGridFilterGroupView";
import CustomFilter from "@fuse/components/AgGridFilterGroupView/components/CustomFilter";
import CustomDropdownEditor from '@fuse/components/AgGridFilterGroupView/components/CustomDropdownEditor';
import ActivityAgGridListing from '@fuse/components/ActivitieLogs/activitiesAgGridListing';
import { handleFilterApplied } from "helper/common";
import {
  openFormViewerDialog,
  setFromData,
} from "../store/formViewDialogReducer";
import { openReportViewerDialog, quickAddedContract } from "../store/reportViewDialogReducer";
import { setfilterlist,setrowGroupModel, setContractId, setCustomFilterData } from "../store/filterParamsReducer";
import { setQuickFilter } from '../../reports/store/reportViewDialogReducer';

function ListView(props) {
  // const [gridApi, setGridApi] = useState(null);
  // const rowGroupPanelShow = "always";
  const table_name = "CONTRACTS";
  const [displayButton, setDisplayButton] = useState(false);
  const [windowHeight, setWindowHeight] = useState(window.innerHeight - 330);
  const [contractDetails, setContractDetails] = useState(null);
  const dispatch = useDispatch();
  const gridRef = useRef();
  const router = useRouter();
  const toast = useToast(dispatch);
  const [contractsMenu_, setContractsMenu_] = useState([]);
  const [contractStatusMenu_, setContractStatusMenu_] = useState([]);
  const [paymentTermMenu_, setPaymentTermMenu_] = useState([]);
  const [serviceProviderMenu_, setServiceProviderMenu_] = useState([]);
  const [slaMenu_, setSlaMenu_] = useState([]);
  const [shippingLocationMenu_, setShippingLocationMenu_] = useState([]);
  const [filterApplied, setFilterApplied] = useState(false);
  const [filterText, setFilterText] = useState();
  const [tabValue, setTabValue] = useState(0)
	const [logs,setLogs] = useState([]);
  const [groupByArr, setGroupByArr] = useState([])
  const [rowGroupPanelShow, setRowGroupPanelShow] = useState('never');
  const callRefreshList = useRef(true);
  const [update, setUpdate] = useState(0)
  const query_data = useSelector((state) => state.reportApp.reportViewDialogReducer.quick_filter);
  const contract_id = useSelector(
    (state) => state.contractsApp.filterParamsReducer.contract_id
  );
  const quick_added_contract = useSelector(
    (state) => state.contractsApp.reportViewDialogReducer.quickAddedContract
  ); 
	const [loadingActivityLog,setLoadingActivityLog] = useState(false);

  const tableHeaders = [
		"contract_number", "total_contract_value", "contract", "start_date", "end_date", "type", "contract_tag", "contract_status", "number_of_assets",
    "sla", "service_provider", "master", "parent_contract", "new/renew", "location", "po_number", "payment_order_date", "billing_cycle",
    "billing_cycle_date", "every", "month", "value", "card_number", "card_holder_name", "source", "amount"
	];

  const tab_value = useSelector(
    (state) => state.reportApp.reportViewDialogReducer.tab_value
  );
  useEffect(()=>{
    setTabValue(tab_value)
  }, [tab_value])
	const frameworkComponents = {
		customFilter: CustomFilter,
    customDropdownEditor: CustomDropdownEditor
	};
  const handleClickOpen = (data) => {
    setContractDetails(data);
    // setOpen(true);
    router.push(`/contract-details/${data.id}`)
    dispatch(setContractId(null));
  };

  function setHeaderName(header) {
    if(header === 'payment_order_date') return 'PO Date'
    if(header === 'payment_order_number') return 'PO Number'
    if (header === "contract_id") {
      return "Contract ID";
    } if (header === "shipping_id") {
      return "Shipping ID";
    } if (header === "billing_id") {
      return "Billing ID";
    } if (header === "client_users_id") {
      return "Client User ID";
    } if(header === "contract_name") {
      return "Contract"
    } 
      return header
        .split("_")
        .map((word) => word.charAt(0).toUpperCase() + word.substring(1))
        .join(" ");
    
  }

  const handelEdit = (data) => {
    dispatch(setFromData(data));
    dispatch(openFormViewerDialog());
  };

  const handleClose = () => {
    setContractDetails(null);
  };

  const handleConfirm = (data) => {
    setContractDetails(data);
  };

  const handleChildClick = (value) => {
		// setTabValue(value)
	}

  const handleDelete = () => {
    axios
      .delete(`/contracts/delete-contract/${contractDetails?.id}`)
      .then((res) => {
        if (res.status === 201) {
          toast.error(res.data.message);
        } else {
          handleClose();
          toast.success(res.data.message);
          props.refresh();
        }
      })
      .catch((err) => {
        console.log(err);
        // toast.error('Something went wrong!');
      });
  };

  const onGridReady = (params) => {
    gridRef.current = params
    setUpdate(update +1)
    // setGridApi(params);
    props.endUsersAccounts.forEach((list) => {
      for (const [fieldName, value] of Object.entries(list)) {
        if (value === "-" || value === ""){
          list[fieldName] = `No ${formatString(fieldName)}`;
        }
      }
    });
    if(router.query.report_name === undefined) {
      if(props.customFilterData !== 'all'){
    	  loadInitialState (params)
      }
    	dispatch(setfilterlist({}));
    	dispatch(setrowGroupModel([]));
    }else{
      setRowGroupPanelShow('always')
    	getReport(params);
    }
  };

  // const onKeyUp = (event) => {
  //   const searchItem = event.target.value;
  //   gridApi.api.setQuickFilter(searchItem);
  // };

  const onColumnMoved = (params) => {
    if (router.query.report_name === undefined) {
      const rows = params.api.getColumnState();
      saveView(rows);
      dispatch(setrowGroupModel(rows))
    }
  };
  function onSortChanged(params){
    if (router.query.report_name === undefined) {
      const rows = params.api.getColumnState();
      saveView(rows);
      dispatch(setrowGroupModel(rows));
    }
  }

  const onColumnPinned = (params) => {
    if (router.query.report_name === undefined) {
      const rows = params.api.getColumnState();
      saveView(rows);
      dispatch(setrowGroupModel(rows))
    }
  };

  function onColumnVisible(params) {
    const rows = params.api.getColumnState();
    dispatch(setrowGroupModel(rows))
    const total_no_of_columns = rows.length;
    let total_hidden_columns = 0;
    rows.forEach((row) => {
      const { hide } = row;
      if (hide) {
        ++total_hidden_columns;
      }
    });
    if (total_hidden_columns < total_no_of_columns) {
      if (router.query.report_name === undefined) {
        // const rows = params.api.getColumnState();
        saveView(rows);
      }
    }
  };

  // const onGridSizeChanged = (params) => {
  //   setWindowHeight(window.innerHeight - 320);
  // };

  const onRangeSelectionChanged = (params) => {
    let columnCount = 0;
    let startRowIndex = 0;
    let endRowIndex = 0;

    const rows = params.api.getCellRanges();

    if (rows.length != 0) {
      columnCount = params.api.getCellRanges()[0].columns.length;
      startRowIndex = params.api.getCellRanges()[0].startRow.rowIndex;
      endRowIndex = params.api.getCellRanges()[0].endRow.rowIndex;
    }

    if (columnCount > 1 || startRowIndex != endRowIndex) {
      setDisplayButton(true);
    } else {
      setDisplayButton(false);
    }
  };

  // const clearSelection = () => {
  //   gridApi.api.clearRangeSelection();
  // };

  function onFilterChanged(event) {
    const rows = event.api.getFilterModel();
    console.log('rows data', rows)

    // to show No result found in column filter
    dispatch(setfilterlist(rows));
    gridRef.current = {...gridRef.current,filterModelArr:rows}
    saveView("N/A", rows, gridRef.current.filterModelArr)
    // validation for no-overlay
    const total_rows = event.api.getDisplayedRowCount();

    if (total_rows === 0) {
      event.api.showNoRowsOverlay();
    } else {
      event.api.hideOverlay();
    }
  }

  function onColumnRowGroupChanged(event) {
    const api = event?.api;
    if (!api) return;
    const groupedColumns = api.getRowGroupColumns();
    if (groupedColumns.length === 0) setGroupByArr([]);
    else setGroupByArr(groupedColumns);

    if (router.query.report_name === undefined) {
      const rows = event.api.getColumnState();
      const first_row = rows[0];
      if (first_row.colId !== "ag-Grid-AutoColumn") {
        dispatch(setrowGroupModel(rows));
        saveView(rows);
      } else {
        dispatch(setrowGroupModel(rows));
      }
    }
    // auto size group columns
    // onRowGroupOpenedAutoSize();
  }

  function getReport(event){
		const {report_name} = router.query;
		const table_name = "contract";
		axios.get(`/reports/view-report?table_name=${table_name}&report_name=${report_name}`)
		.then(results=>{
			const model = JSON.parse(results.data.data.filter);
			event.api.setFilterModel(model);
			const row_model = JSON.parse(results.data.data.row_model);
			event?.api.applyColumnState({ state: row_model });
		})
		.catch(err=>{
			console.log(err);
		})
	}

  function saveView(rows, filter, filterModelArr=null){
    let payload = {}
  //  if(filter.end_date){
    // /  filter.end_date.dateFrom  = dateReformatTo_mmm_dd_yyyy()
    // }
		if(rows === 'N/A'){
			payload = {
				filter:  JSON.stringify(filterModelArr ?? filter),
				table_name
			}
		}else{
			payload = {
				order:  JSON.stringify(rows),
				table_name
			}
		}
		axios.post('/user-view/save-view-order',payload)
		.then(()=>{
			console.log('view updated')
		})
		.catch(err=>{
			console.log(err);
		})
  }

  const fetchAllSuggestion = () => {
    axios
      .get(`contracts/get-all-suggestion`)
      .then((response) => {
        const {
          paymentTerm,
          shipping,
          contractStatus,
          sla,
          serviceProvider,
        } = response.data.data;
        setContractStatusMenu_(
          contractStatus.map((item) => {
            return {
              id: item.id,
              contract_status_name: item.contract_status_name,
              color: item.status_color.code,
            };
          })
        );
        setPaymentTermMenu_(paymentTerm);
        setServiceProviderMenu_(serviceProvider);
        setSlaMenu_(sla);
        setShippingLocationMenu_(shipping);
      })
      .catch((err) => {
        console.log("err", err);
        //   toast.error('Something went wrong!')
      });
  };

  function fetchContractType() {
    axios
      .get(`contracts/get-contract-types`)
      .then((response) => {
        // console.log(response.data.data)
        const check = response.data.data.map((item) => item.display_name);
        setContractsMenu_(check);
      })
      .catch((err) => {
        console.log("err", err);
        // toast.error('Something went wrong!')
      });
  }

  useEffect(() => {
    fetchContractType();
    fetchAllSuggestion();
    if(router.params?.id){
      handleClickOpen({id: router.params.id})
    }
  }, []);

  useEffect(() => {
    gridRef?.current?.api?.setQuickFilter(query_data);
  }, [query_data]);
  
  useEffect(() => {
    if (contract_id && props.endUsersAccounts.length > 0) {
      const contract = props.endUsersAccounts.find(
        (contract) => contract.id === contract_id
      );
      handleClickOpen(contract);
    }
  }, [contract_id, props.endUsersAccounts.length]);
  // useEffect(()=>{
	// 	onGridReady()
  //   return () => {
  //     dispatch(setQuickFilter(null))
	// 	}
	// },[props.endUsersAccounts])

  function formatLogs (data) {
		return data.map((item) => {
			return {
				id:item.id,
				action_id: `act${item.id}`,
				contract_number: item.contract_header?.entity_external_platform_id ?? '-',
				action_date_and_time: item.created_at,
				name: `${item.user_companies_user?.first_name} ${item.user_companies_user?.last_name}`,
				action: actionConst[item.action_name],
				description: createDescription(item.action_name, { 
					first_name: item.user_companies_user?.first_name, 
					last_name: item.user_companies_user?.last_name,
					field_name: item?.field_name === 'contract_status' ? 'contract_tag' : item?.field_name,
					current_value: item?.current_value,
					previous_value: item?.previous_value
				}),
				previous_value: item?.previous_value ? formatDateValues(item?.field_name, item?.previous_value) : '-',
				current_value: item?.current_value ? formatDateValues(item?.field_name, item?.current_value) : '-',
				user_role: item.user_companies_user?.roles_end_user.display_name,
				field_name: formatString(item?.field_name === 'contract_status' ? 'contract_tag' : item?.field_name) || '-',
			}
		})
	}

  const createDescription = (method, data) => {
    let descriptionText = ''
    switch(method){
      case 'create': {
        descriptionText = `${data.first_name} ${data.last_name} created this contract`
        break
      }
      case 'update': {
        descriptionText = `${data.first_name} ${data.last_name} updated ${formatString(data.field_name)} from ${formatDateValues(data.field_name, data.previous_value)} to ${formatDateValues(data.field_name, data.current_value)}`
        break
      }
      case 'delete': {
        descriptionText = `${data.first_name} ${data.last_name} deleted this contract`
        break
      }
      case 'archive': {
        descriptionText = `${data.first_name} ${data.last_name} archived this contract`
        break
      }
      case 'restore': {
        descriptionText = `${data.first_name} ${data.last_name} restored this contract`
        break
      }
      case 'upload_csv_created': {
        descriptionText = `${data.first_name} ${data.last_name} created this contract`
        break
      }
      case 'upload_csv_updated': {
        descriptionText = `${data.first_name} ${data.last_name} updated this contract`
        break
      }
      case 'set_master': {
        descriptionText = `${data.first_name} ${data.last_name} set this contract as Master for contract ${data.current_value}`
        break
      }
      case 'file_added': {
        descriptionText = `${data.first_name} ${data.last_name} added a file named: ${data.current_value}`
        break;
      }
      case 'file_removed': {
        descriptionText = `${data.first_name} ${data.last_name} removed a file named: ${data.previous_value}`
        break;
      }
      default: {
        descriptionText = ''
        break
      }
    }
    return descriptionText
  }

  const formatDateValues = (fieldName, value) => {
    if(!value) return '-'
    const dateFields = ['contract_start_date', 'contract_end_date', 'po_date', 'billing_cycle_date']
    if(dateFields.includes(fieldName)) {
      // if(field_name === 'po_date') return dateReformatTo_mmm_dd_yyyy(value)
      return value ==='-'? '-' : dateReformatTo_mmm_dd_yyyy(new Date(value).toISOString())
    }
    if(fieldName === 'billing_amount' || fieldName === 'total_contract_value') {
      return Number(value).toLocaleString(undefined, {  minimumFractionDigits: 2 , maximumFractionDigits: 2 });
    }
    if(fieldName === 'billing_cycle' || fieldName === 'billing_cycle_duration') {
      return `${value  }  months`;
    }
      return value
  }


  useEffect( () => {
    if(quick_added_contract){
      props.refresh()
      dispatch(quickAddedContract())
    }
  }, [quick_added_contract])

  const actionConst = {
    create: 'CREATED',
    update: 'UPDATED',
    delete: 'DELETED',
    set_master: 'SET MASTER',
    archive: 'ARCHIVED',
    restore: 'RESTORED',
    upload_csv_created: 'CSV UPLOAD',
    upload_csv_updated: 'CSV UPLOAD',
    file_added: 'ADDED',
    file_removed: 'REMOVED'
  }

  function getLogs () {
    setLoadingActivityLog(true)

		axios.get(`/contracts/get-all-activities`).then(({data})=>{
      setLoadingActivityLog(false)

			setLogs(formatLogs(data.data));
		})
		.catch((err)=>{
			console.log(err,'cannot fetch logs');
		}).finally(()=>{
		})
	}

  function loadInitialState(params) {
    axios
      .get(`/user-view/show-view-order?table_name=${table_name}`)
      .then((results) => {
        const { data } = results.data;
        if (data !== null) {
          const order = JSON.parse(data.order);
          const filter = JSON.parse(data.filter);
          gridRef.current = {...gridRef.current,filterModelArr:filter}
          params?.api.applyColumnState({ state: order });
          params?.api.setFilterModel(filter);
          if (Object.keys(filter || {})?.length) {
            setFilterApplied(true)
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  useEffect(() => {
    // if(filterApplied){
    //   toast.success("Filters have been applied")
    // }
  },[filterApplied])

  function onCellValueChanged(e) {
    // if(e.colDef.field === 'contract_type'){
    // 	contract_type = contractsMenu_.find(i)
    // }
    const contract_status = e.data.original_info.contract_status_object;
    let {contract_name} = e.data.original_info;
    let {contract_description} = e.data.original_info;
    let {payment_amount} = e.data.original_info;
    let payment_term = e.data.original_info.payment_term_obj;
    let service_provider = e.data.original_info.service_provider_object;
    let service_level_agreement =
      e.data.original_info.service_level_agreement_object;
    let location = e.data.original_info.location_object.id;
    let {contract_type} = e.data.original_info;
    let po_number = e.data.original_info.payment_order_number;

    if (e.colDef.field === "payment_order_number") {
      po_number = e.newValue;
      if (!po_number) {
        toast.error("Payment Order Number is required");
        props.refresh();
        return;
      }
    }
    if (e.colDef.field === "contract_type") {
      contract_type = e.newValue;
    }
    if (e.colDef.field === "contract_name") {
      contract_name = e.newValue;
      if (!contract_name) {
        toast.error("Contract Name is required");
        props.refresh();
        return;
      }
    }
    if (e.colDef.field === "contract_description") {
      contract_description = e.newValue;
    }
    if (e.colDef.field === "payment_amount") {
      payment_amount = e.newValue;
      if (!payment_amount) {
        toast.error("Payment Amount is required");
        props.refresh();
        return;
      }
    }
    if (e.colDef.field === "status") {
      if(callRefreshList.current) props.refresh();
      callRefreshList.current = true
      return
      // contract_status = contractStatusMenu_.find(
      //   (i) => i.contract_status_name === e.newValue?.split(",")[0]
      // );
    }
    if (e.colDef.field === "payment_term") {
      payment_term = paymentTermMenu_.find((i) => i.display_name === e.newValue);
    }
    if (e.colDef.field === "service_level_agreement") {
      service_level_agreement = slaMenu_.find((i) => i.sla_name === e.newValue);
    }
    if (e.colDef.field === "service_provider") {
      service_provider = serviceProviderMenu_.find(
        (i) => i.service_provider_name === e.newValue
      );
    }
    if (e.colDef.field === "location") {
      location = shippingLocationMenu_.find(
        (option) =>
          `${option.location_name} - ${option.address1}, ${option.city}, ${option.state}, ${option.country}` ==
          e.newValue
      ).id;
    }

    const payload = {
      id: e.data.id,
      contract_name,
      contract_description,
      contract_start_date: e.data.original_info.contract_start_date,
      contract_end_date: e.data.original_info.contract_end_date,
      contract_status: {
        id: contract_status ? contract_status.id : e.data.contract_status.id,
        contract_status_name: contract_status? contract_status.contract_status_name : contract_status.contract_status_name,
      },
      shipping_id: location,
      contract_type,
      master: e.data.original_info.master,
      parent_contract_id: e.data.original_info.parent_contract_object?.id || 0,
      contract_description,
      provider: {
        id: service_provider.id,
        service_provider_name: service_provider.service_provider_name,
      },
      sla: {
        id: service_level_agreement.id,
        sla_name: service_level_agreement.sla_name,
      },
      renewal: e.data.original_info.renewal,
      // support_phone_number: e.data.original_info.text_contact_number,
      poNumber: po_number,
      poDate: e.data.original_info.payment_order_date,
      country: { name: "United States", code: "US", currency: "USD" },
      // no_reminder: false,
      // reminder: { term45: true, term30: false },
      // textMessage: true,
      paymentAmount: payment_amount,
      paymentTerm: {
        id: payment_term.id,
        display_name: payment_term.display_name,
      },
    };

    axios
      .put("/contracts/update-contract-manually", payload)
      .then((response) => {
        if (response.status === 201) {
          toast.error(response.data.message);
        } else {
          toast.success("Contract Updated Successfully.");
          props.refresh();
        }
      })
      .catch((err) => {
        console.log("212=>", err);
        // toast.error('Something went wrong!')
      });
  }

  const generateHeaderLabel = (header) => {
    
    return header
      .split("_")
      .map((word) => {
        // if(word in transform_words) return transform_words[word];
        return word.charAt(0).toUpperCase() + word.substring(1);
      })
      .join(" ");
  };

  // function onRowGroupOpenedAutoSize() {
  //   const allColumnIds = [];
  //   gridApi.api.getColumnState().forEach((column) => {
  //     // only auto-sizing the auto-generated group column
  //     if (column.colId === "ag-Grid-AutoColumn") {
  //       allColumnIds.push(column.colId);
  //     }
  //   });
  //   gridApi.api.autoSizeColumns(allColumnIds, false);
  // }

  const headersNotToBeListed = [
    "id",
    "contract_status_object",
    "parent_contract_object",
    "contract_description",
    "service_level_agreement_object",
    "service_provider_object",
    "contract_type_object",
    "source",
    "billing_cycle_",
    "billing_cycle_date_exact",
    "po_date_exact",
    "subscription_payment_id",
    "subscription_billing_id",
    "payment_term_id",
    // "payment_order_date",
    'po_date',
    "location_object",
    "contract_payment_object",
    "master_object",
    "original_info",
    "location_id",
    "company_name",
    // "amount",
    // "total_contract_value",
    "manually_added",
    "currency",
    "payment_term",
    'po_number',
    // "payment_order_number",
    // "reminder",
    // "text_contact_number",
    "related_asset",
    "subscription_billing",
    "subscription_payment",
  ];

  const notEditableHeader = [
    "contract_number",
    "new/renew",
    "parent_contract",
    // "payment_order_date",
    // "reminder",
    // "text_contact_number",
    "currency",
    // "source",
    "master"
  ];

  const openInNewTab = (url) => {
    window.open(url, "_blank", "noreferrer");
  };

  function redirectToAssetProfile(event){
    if(event.value === 0){
      return
    }
		// dispatch(setAssetsForRedirection(event.data.related_asset))
		// localStorage.setItem('contract_header_id',event.data.id)
		openInNewTab(`/assets-list?contract_header_id=${event.data.id}`)
		// router.push('/assets');
	}

  const handleAddContract = () => {
    dispatch(openFormViewerDialog());
  }

  const handleAddReport = () => {
    dispatch(openReportViewerDialog())
  }

  useEffect(()=>{
		(tabValue === 1) && getLogs()
	},[tabValue])

  const getValues = (status_name, row_id)=>{
		let status = null;
		status = contractStatusMenu_.find(
			(item) => item.contract_status_name === status_name
		);
		if(!status) return
		const payload = { status_id: status ? status.id : e.data.status.id,
			contract_id: parseInt(row_id)
		}
		axios.post(`/end-user-contracts/edit-status`, payload)
		.then(()=>{
			toast.success("Contract updated successfully")
      callRefreshList.current = false
			props.refresh();
		})
		.catch(err=>{
			console.log(err);
		})
  }

  const clearRedirectionFilter = () => {
    if(props.customFilterData === 'all'){
      dispatch(setCustomFilterData(null))
    }

      setFilterApplied(false);
      setFilterText()
  }
  
  const [filterData, setFilterData] = useState(JSON.parse(sessionStorage.getItem('redirectFilter')));
	 useEffect(() => {
		 setTimeout(async () => {
		   const filterArray = filterData;
       if (filterArray && gridRef.current?.api) {
         console.log('filterArray',filterArray)
			   sessionStorage.removeItem("redirectFilter")
         await handleFilterApplied(filterArray, gridRef.current?.api, true);
         setFilterData()
          if (Object.keys(filterArray?.filterModel)?.length) {
           setFilterApplied(true)
           setFilterText('User is currently viewing the contract page with the following filters…');
         }
         setUpdate(update + 1)
		   }
		 }, 1000)
	  }, [gridRef.current?.api])

  return (
    <>
      {(tabValue === 0) && <AgGridFilterGroupView
				tableRef={gridRef} 
				setRowGroupPanelShow={setRowGroupPanelShow} 
				groupByArrFromList ={ groupByArr }
				tableName= "Contract"
				displayTableName="Contracts"
        logs={logs}
        key={update}
				onClick={handleChildClick}
        onClickAddButton={handleAddContract}
        onClickAddReportButton={handleAddReport}
        clearRedirectionFilter={clearRedirectionFilter}
        addPermission = {props.createContractPermission}
        customFilterData={props.customFilterData}
			/>}
      {(tabValue === 1) && (<ActivityAgGridListing module="Contract" logs={logs} displayTableName="Contracts"
      addPermission = {props.createContractPermission}				
      loadingActivityLog={loadingActivityLog}
      />)}
      {(tabValue === 0) &&
        <div
          className="ag-theme-alpine"
          style={{
            width: "100%",
            height: windowHeight + 90,
            fontSize: "12px",
          }}
        >
            {filterApplied && <p style={{ margin: '4px' }}>{filterText || 'Filters have been applied'}</p>}
          {/* {filterApplied && <p style={{margin: '4px'}}>Filters have been applied</p>} */}
          <AgGridReact
            ref={gridRef}
            theme="legacy"
            suppressRowClickSelection
            onGridReady={onGridReady}
            animateRows
            rowData={props.endUsersAccounts}
            rowHeight={30}
            headerHeight={44}
            // Set the desired sheet name
            defaultExcelExportParams={{
              sheetName: 'Dalos-Source'
            }}
            defaultColDef={{
              enableRowGroup:true,
              resizable: true
            }}
            // no rows overlay
            overlayNoRowsTemplate="<span>No Result Found</span>"
            // Row Grouping conditions
            showOpenedGroup
            suppressDragLeaveHidesColumns
            suppressMakeColumnVisibleAfterUnGroup
            // autoGroupColumnDef={{ minWidth: 500 }}
            rowGroupPanelShow={rowGroupPanelShow}
            onColumnMoved={onColumnMoved}
            onColumnPinned={onColumnPinned}
            onColumnVisible={onColumnVisible}
            onSortChanged={onSortChanged}
            groupHeaderHeight={1}
            // headerHeight={15}
            floatingFiltersHeight={40}
            components={frameworkComponents}
            // status bar enabled on range selection
            enableRangeSelection
            statusBar={{
              statusPanels: [
                {
                  statusPanel: "agAggregationComponent",
                },
              ],
            }}
            // to check the the no. of rows selected during range selection
            onRangeSelectionChanged={onRangeSelectionChanged}
            onFilterChanged={onFilterChanged}
            // on column group changed
            onColumnRowGroupChanged={onColumnRowGroupChanged}
            // groupMaintainOrder={true}

            pagination
            columnDefs={[
              {
                lockPosition: true,
                rowSelection: "single",
                width: 100,
                minWidth: 100,
                maxWidth: 100,
                suppressSizeToFit: true,
                headerName: "Actions",
							suppressMenu: true,          
							suppressHeaderMenuButton: true,
							sortable: false,
                pinned: 'right',
                className: "action_field",
                lockPinned: true,
                cellRenderer: ({ data }) => {
                  if (data) {
                    return (
                      <>
                        {props.viewContractPermission && <Tooltip id="view" title="View" placement="top">
                          {/* <Icon
                          onMouseDown={() => handleClickOpen(data)}
                          style={{
                            color: "#1d2939",
                            paddingBottom: "5px",
                            paddingRight: "30px",
                            fontSize: "15px",
                            cursor: "pointer",
                          }}
                        >
                          visibility
                        </Icon> */}
                          <i style={{ color: '#1D2939', fontSize: '20px', padding: '0 6px', cursor: 'pointer' }} className="ti ti-eye" onClick={() => handleClickOpen(data)} />
                        </Tooltip>}
                        {props.updateContractPermission && (
                          <Tooltip id="edit" title="Edit" placement="top">
                            {/* <Icon
                            onMouseDown={() => handelEdit(data)}
                            style={{
                              color: "#1d2939",
                              paddingBottom: "5px",
                              paddingRight: "30px",
                              fontSize: "15px",
                              cursor: "pointer",
                            }}
                          >
                            edit
                          </Icon> */}
                            <i style={{ color: '#1D2939', fontSize: '20px', padding: '0 6px', cursor: 'pointer' }} className="ti ti-pencil" onClick={() => handelEdit(data)} />
                          </Tooltip>
                        )}
                        {/* {(props.deleteContractPermission.length > 0 || props.deleteContractPermission === 'all' ||
                        (props.deleteContractPermission.map(i=>i === data.location_obj.id).length >0)
                        ) && */}
                        {props.deleteContractPermission && (
                          <Tooltip id="delete" title="Archive" placement="top">
                            {/* <Icon
                            onMouseDown={() => handleConfirm(data)}
                            style={{
                              color: "#1d2939",
                              paddingBottom: "5px",
                              paddingRight: "30px",
                              fontSize: "15px",
                              cursor: "pointer",
                            }}
                          >
                            archive
                          </Icon> */}
                            <i style={{ color: '#1D2939', fontSize: '20px', padding: '0 6px', cursor: 'pointer' }} className="ti ti-archive" onClick={() => handleConfirm(data)} />
                          </Tooltip>
                        )}
                        {/* } */}
                      </>
                    );
                  }
                  return <></>;
                
                },
              },
                ...tableHeaders.filter((item) => !headersNotToBeListed.includes(item.trim())).map((header) => {
                  if (notEditableHeader.includes(header)) {
                    return {
                      field: header,
                      key: header,
                      headerName: generateHeaderLabel(header),
                      sortable: true,
                      // floatingFilter = { true } 
                      headerComponent: (props) => (CustomFilter(props, header, gridRef)),
                      filter: "agTextColumnFilter",
                      flex: 1,
                      minWidth: 200,
                    }
                  }
                  if (header === "contract_type") {
                    return {
                      field: header,
                      key: header,
                      sortable: true,
                      // floatingFilter = { true } 
                      headerComponent: (props) => (CustomFilter(props, header, gridRef)),
                      filter: "agTextColumnFilter",
                      flex: 1,
                      minWidth: 200,
                      headerName: "Contract Type",
                      suppressSizeToFit: true,
                    }
                  }
                  if (header === "payment_term") {
                    return {
                      field: header,
                      key: header,
                      sortable: true,
                      headerName: "Payment Term",
                      // floatingFilter = { true } 
                      headerComponent: (props) => (CustomFilter(props, header, gridRef)),
                      filter: "agTextColumnFilter",
                      flex: 1,
                      minWidth: 200,
                    }
                  }
                  if (header === "location") {
                    return {
                      field: header,
                      key: header,
                      sortable: true,
                      headerName: "Location",
                      // floatingFilter = { true } 
                      headerComponent: (props) => (CustomFilter(props, header, gridRef)),
                      filter: "agTextColumnFilter",
                      flex: 1,
                      minWidth: 200,
                    }
                  }
                  if (header === "service_level_agreement") {
                    return {
                      field: header,
                      key: header,
                      sortable: true,
                      headerName: "Service Level agreement",
                      // floatingFilter = { true } 
                      headerComponent: (props) => (CustomFilter(props, header, gridRef)),
                      filter: "agTextColumnFilter",
                      flex: 1,
                      minWidth: 200,
                    }
                  }
                  if (header === "service_provider") {
                    return {
                      field: header,
                      key: header,
                      sortable: true,
                      headerName: "Service Provider",
                      // floatingFilter = { true } 
                      headerComponent: (props) => (CustomFilter(props, header, gridRef)),
                      filter: "agTextColumnFilter",
                      flex: 1,
                      minWidth: 200,
                    }
                  }
                  if (header === "status") {
                    return {
                      field: header,
                      key: header,
                      sortable: true,
                      headerName: "Service Provider",
                      cellEditorPopup: true,
                      suppressSizeToFit: true,
                      cellEditor: 'customDropdownEditor',
                      // floatingFilter = { true } 
                      headerComponent: (props) => (CustomFilter(props, header, gridRef)),
                      filter: "agTextColumnFilter",
                      flex: 1,
                      minWidth: 200,
                      cellEditorParams: {
                        values: contractStatusMenu_.map(
                          (s) => `${s.contract_status_name},${statusColors[s.color]}`
                        ),
                        getValue: getValues
                        
                      },
                      headerName: "Contract Tag",
                      editable: props.updateContractPermission,
                      onCellValueChanged,
                      cellRenderer: (event) => {
                        if (event.colDef.field === "status") {
                          return (
                            <span>
                              <span
                                style={{
                                  height: "10px",
                                  width: "10px",
                                  marginTop: "2px",
                                  borderRadius: "50%",
                                  display: "inline-block",
                                  // backgroundColor: event.data?.contract_status_object ?.status_color?.code,
                                  backgroundColor:
                                    event.value?.split(",")[1] ??
                                    event.data?.contract_status_object?.status_color?.code
                                }}
                              />
                              <span style={{ marginLeft: "5px" }}>
                                {/* {
                                  event.data?.contract_status_object
                                    ?.contract_status_name
                                } */}
                                {event.value?.split(",")[0]}
                              </span>
                            </span>
                          );
                        } if (
                          event.colDef.headerName === "Group" &&
                          event.node.field === "status"
                        ) {
                          return (
                            <>
                              <span>{event.value}</span>
                            </>
                          );
                        }
                        return (
                          <>
                            <span>{event.value}</span>
                          </>
                        );
                      }
                    }
                  } if (
                    header === "shipping_id" ||
                    header === "billing_id" ||
                    header === "client_users_id"
                  ) {
                    if (header === "shipping_id") {
                      return {
                        field: header,
                        key: header,
                        headerName: "Location ID",
                        sortable: true,
                        filter: true,
                        headerComponent: (props) => (CustomFilter(props, header, gridRef)),
                        // floatingFilter={true}
                        flex: 1,
                        minWidth: 200,
                      }
                    }
                    return {
                      field: header,
                      key: header,
                      headerName: setHeaderName(header),
                      sortable: true,
                      filter: true,
                      headerComponent: (props) => (CustomFilter(props, header, gridRef)),
                      // floatingFilter={true}
                      flex: 1,
                      minWidth: 200,
                    }
                  } if (['start_date', 'end_date', 'billing_cycle_date', 'payment_order_date'].includes(header)) {
                    return {
                      field: header,
                      key: header,
                      headerName: header === 'payment_order_date' ? generateHeaderLabel(header) : setHeaderName(header),
                      sortable: true,
                      headerComponent: (props) => (CustomFilter(props, header, gridRef)),
                      // floatingFilter={true}
                      flex: 1,
                      minWidth: 200,
                      filter: "agTextColumnFilter",
                      cellRenderer: (event) => {
                        return (
                          <span>{!event.value || ['No Billing Cycle Date', 'No Payment Order Date'].includes(event.value) ? event.value : dateReformatTo_mmm_dd_yyyy(event.value)}</span>
                        )
                      }
                    }
                  } if (header === 'number_of_assets') {
                    return {
                      key: header,
                      field: header,
                      suppressSizeToFit: true,
                      suppressRowClickSelection: true,
                      headerName: generateHeaderLabel(header),
                      sortable: true,
                      filter: "agTextColumnFilter",
                      flex: 1,
                      minWidth: 200,
                      headerComponent: (props) => (CustomFilter(props, header, gridRef)),
                      // floatingFilter = {true}
                      cellRenderer: (event) => {
                        return (<a
                          style={{
                            height: '10px',
                            width: '10px',
                            color: 'black',
                            cursor: 'pointer',
                            marginTop: '2px',
                            borderRadius: '50%',
                            display: 'inline-block',
                          }}
                          onClick={() => redirectToAssetProfile(event)}
                          variant="subtitle1"
                        >
                          <><span>{event.value}</span></>
                        </a>)
                      }
                    }
                  }
                  return {
                    field: header,
                    key: header,
                    // editable={true}
                    // onCellValueChanged = {onCellValueChanged}
                    flex: 1,
                    minWidth: 200,
                    headerName: setHeaderName(header),
                    sortable: true,
                    headerComponent: (props) => (CustomFilter(props, header, gridRef)),
                    // floatingFilter={true}
                      
                    filter: "agTextColumnFilter",
                  }
                })
            ]}
           />
          <GeneralModal
            open={contractDetails}
            title="Are you sure to archive contract?"
            text={
              <h4>
                Are you sure to Archive this Contract named as{" "}
                <b>{contractDetails?.contract_name}</b>?
              </h4>
            }
            detailMessage="Your contract will be moved to archive contract if you proceed"
            handleClose={handleClose}
            handleConfirm={handleDelete}
            actionButtonName="Yes, Proceed!"
          />
        </div>
      }
    </>
  );
}

export default ListView;
